export default defineNuxtPlugin(() => {
  const store = useMyChatStore();
  const config = useRuntimeConfig();

  const load = useScript(
    {
      src: config.public.releasyChatBaseUrl + config.public.releasyChatScript,
      type: 'text/javascript',
      async: true,
      tagPosition: 'bodyClose',
      crossorigin: false,
      id: 'data-chatframe',
      'data-genesys-url':
        'https://api.mypurecloud.de/api/v2/webchat/guest/conversations',
      'data-identifier-prefix': 'a2be3m1',
      'data-chaturl': config.public.releasyChatBaseUrl,
      'data-lang': 'sv_SE',
      'data-organizationid': config.public.releasyOrganizationId,
      'data-deploymentid': config.public.releasyDeploymentId,
    },
    {
      trigger: 'manual',
    },
  );

  const loadSecond = useScript(
    {
      src:
        config.public.releasyChatBaseUrl + config.public.releasySettingsScript,
      type: 'text/javascript',
      async: true,
      tagPosition: 'bodyClose',
      crossorigin: false,
      id: 'settings-chatframe',
    },
    {
      trigger: 'manual',
    },
  );

  const adjustChatContainerHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  window.addEventListener('load', adjustChatContainerHeight);
  window.addEventListener('resize', adjustChatContainerHeight);

  window.addEventListener('scroll', () => {
    const chatBannerFull = document.querySelector('.chat-banner-full');
    const scrollPosition = window.scrollY;

    if (chatBannerFull) {
      if (scrollPosition >= 1) {
        chatBannerFull.classList.add('fixed');
      } else {
        chatBannerFull.classList.remove('stuck', 'fixed');
        chatBannerFull.classList.remove('stuck', 'stuck');
      }
    }
  });

  load.onError((e) => {
    console.error(
      `Script load error for CustomerChatHalebopmsg_electra.js:`,
      e,
    );
  });

  loadSecond.onError((e) => {
    console.error(`Second Script load error for settingsHalebop.js:`, e);
  });

  load.onLoaded(() => {
    loadSecond.load();
  });

  if (
    config.public.releasyChatBaseUrl &&
    config.public.releasyChatScript &&
    config.public.releasyOrganizationId &&
    config.public.releasyDeploymentId &&
    config.public.releasySettingsScript
  ) {
    load.load();

    setTimeout(() => {
      store.START_INTERVAL();
    }, 1000);
  }
});
